export default "__VITE_ASSET__be774779__"